import { App } from 'vue';
import Virtualized from './src/virtualized.vue';

Virtualized.install = (app: App): void => {
    app.component(Virtualized.name, Virtualized);
};

export default Virtualized;

declare module 'vue' {
    export interface GlobalComponents {
        PtVirtualized: typeof Virtualized;
    }
}
